module.exports = __webpack_public_path__ + "static/media/12.99db8f6c.jpg";